import React from "react"
import PropTypes from "prop-types"

const Hours = ({ hours }) => {
  return hours.map(dayHour => <span key={dayHour}>{dayHour}</span>)
}

Hours.propTypes = {
  hours: PropTypes.arrayOf(PropTypes.string),
}

export default Hours
